import * as React from "react";
import { cn } from "@/lib/utils";

export const Skeleton = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden
      className={cn(
        "rounded-sm bg-[linear-gradient(90deg,var(--skeleton-from)_0%,var(--skeleton-via)_50%,var(--skeleton-from)_100%)] bg-[length:200%_100%] animate-skeleton-shimmer",
        className,
      )}
      {...props}
    />
  ),
);
Skeleton.displayName = "Skeleton";

export function SkeletonText({
  lines = 3,
  className,
}: {
  lines?: number;
  className?: string;
}) {
  return (
    <div className={cn("space-y-2", className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={cn("h-3", i === lines - 1 ? "w-2/3" : "w-full")}
        />
      ))}
    </div>
  );
}
